import './range_input.scss';
import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme } from '..';
const RangeInput = _ref => {
  let {
    minValue,
    maxValue,
    allowedMinValue = minValue,
    allowedMaxValue = maxValue,
    step,
    value,
    label,
    onChange,
    className,
    valueLabel
  } = _ref;
  const {
    theme
  } = useTheme();
  const [internalValue, setInternalValue] = useState(value);
  useEffect(() => {
    setInternalValue(value);
  }, [value]);
  const handleOnChange = e => {
    if (e.target.value < allowedMinValue || e.target.value > allowedMaxValue) return;
    const newVal = Number(e.target.value);
    setInternalValue(newVal);
    if (onChange) onChange(newVal);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-range', className, theme)
  }, /*#__PURE__*/React.createElement("label", {
    className: "wrts-range-label",
    htmlFor: "range-input"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "wrts-range-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    style: {
      background: `linear-gradient(to right, #8952DA 0%, #8952DA ${(internalValue - minValue) * 100 / (maxValue - minValue)}%, ${theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'} ${(internalValue - minValue) * 100 / (maxValue - minValue)}%, ${theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'} 100%)`
    },
    className: "wrts-range-input",
    type: "range",
    min: minValue,
    max: maxValue,
    value: internalValue,
    step: step,
    onChange: handleOnChange
  }), /*#__PURE__*/React.createElement("span", {
    className: "wrts-range-value"
  }, valueLabel || internalValue)));
};
RangeInput.defaultProps = {
  step: 1,
  label: '',
  value: 0
};
RangeInput.propTypes = {
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  allowedMinValue: PropTypes.number,
  allowedMaxValue: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number.isRequired,
  label: PropTypes.string,
  valueLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(RangeInput);